export default {
  props: {
    activeFilters: Object,
    default: () => {}
  },
  data: () => ({
    isLoading: false
  }),
  methods: {
    async onDownload() {
      this.isLoading = true

      try {
        const response = await this.$http.get('/rest/statistic/getExcel', {
          params: { ...this.activeFilters },
          responseType: 'blob'
        })

        let filename = 'download.xlsx';
        const disposition = response.headers['content-disposition'];

        if (disposition && disposition.indexOf('filename=') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } finally {
        this.isLoading = false
      }
    }
  }
}